// Day 2.5 -- "Martian Soft Intelligence" visual system.
//
// The one shared surface primitive every card-shaped thing in the
// console should render through, instead of each page hand-repeating
// `rounded-[var(--radius-card)] border ... shadow-[var(--shadow-card)]`
// (the pattern this file replaces -- see AIDiscoveryCommandCenterPage.js's
// local `LiveKpi` for the exact div this was extracted from).
//
// Three tones, matching the Day 2.5 design proposal exactly:
//   flat  -- the existing, unchanged --shadow-card/--radius-card look.
//            Default, so any page not yet migrated to "raised"/"inset"
//            still gets a sane, already-shipped appearance.
//   raised -- the ONE focal card per view (--shadow-raised,
//            --radius-card-soft). Never applied to more than a small
//            number of elements on a page -- if everything is raised,
//            nothing is.
//   inset  -- a "carved-in" ground for evidence/inputs/neutral or empty
//            states (--shadow-inset, --radius-card-soft). Deliberately
//            the tone used for NOT_AVAILABLE/UNKNOWN/empty content, so a
//            more finished-looking neumorphic surface never implies more
//            completeness than the data actually has (Phase 6's own
//            "restrained" rule for neutral states).
import { cn } from "@/lib/utils";

const TONE_STYLES = {
  flat: "border border-[var(--border)] bg-[var(--surface)] shadow-[var(--shadow-card)] rounded-[var(--radius-card)]",
  raised: "border border-[var(--border-light)] bg-[var(--surface-raised)] shadow-[var(--shadow-raised)] rounded-[var(--radius-card-soft)]",
  inset: "border border-[var(--border-light)] bg-[var(--surface-inset)] shadow-[var(--shadow-inset)] rounded-[var(--radius-card-soft)]",
};

export function SurfaceCard({ tone = "flat", as: Tag = "div", className, children, ...props }) {
  return (
    <Tag className={cn(TONE_STYLES[tone] || TONE_STYLES.flat, "transition-shadow duration-150", className)} {...props}>
      {children}
    </Tag>
  );
}
